import { render, staticRenderFns } from "./TicketExpense.vue?vue&type=template&id=2eba4d08&scoped=true&"
import script from "./TicketExpense.vue?vue&type=script&lang=js&"
export * from "./TicketExpense.vue?vue&type=script&lang=js&"
import style0 from "./TicketExpense.vue?vue&type=style&index=0&id=2eba4d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba4d08",
  null
  
)

export default component.exports